import { tryCatch } from 'utils/common';
import { $fetch } from 'utils/request';
import { TRANSLATE_SLUG } from 'utils/routes';

type TGetSlug = {
  lang: string;
  targetLanguage: string;
  slug: string;
};

export async function getSlug({ lang, targetLanguage, slug }: TGetSlug) {
  const { data, error } = await tryCatch(
    $fetch<{ slug: string | null }>({
      path: TRANSLATE_SLUG,
      base: window.location.origin,
      query: { lang, targetLanguage, slug },
    }),
  );
  if (error) {
    return slug;
  }
  // we find in the response array the first element that matches de query and language;
  if (!data.slug) {
    return slug;
  }
  return data.slug;
}
